'use client';

import * as React from 'react';

/**
 * Registers the service worker that makes CPCel installable and usable with no
 * connection. Registration is deliberately deferred until after load so it
 * never competes with the first paint on a slow connection.
 */
export function ServiceWorkerRegistrar() {
  React.useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    if (process.env.NODE_ENV === 'development') return;

    const register = () => {
      navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {
        // An unavailable service worker degrades the app to online-only, which
        // is a worse experience but not a broken one.
      });
    };

    if (document.readyState === 'complete') register();
    else window.addEventListener('load', register, { once: true });
  }, []);

  return null;
}
